import React from 'react'

export default function Activate() {
  return (
    <div>Thank you for signing up! Please be patient, as we manually activate your account.</div>
  )
}
